
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.991 6.044C11.993 6.029 12 6.015 12 6c0-.016-.008-.029-.009-.044-.002-.018.002-.035 0-.052-.005-.018-.015-.034-.021-.051a.472.472 0 00-.035-.086c-.008-.014-.01-.03-.019-.044l-1-1.5a.5.5 0 00-.833.554l.482.723H8.978C8.585.73 2.615.01 2.552.003a.5.5 0 00-.11.994c.009 0 .171.02.43.072L.068 5.743c-.008.013-.01.028-.018.041a.496.496 0 000 .431c.007.014.01.029.018.042l2.808 4.678c-.24.045-.399.064-.434.069a.5.5 0 00.111.993c.063-.007 6.033-.727 6.426-5.497h1.587l-.482.722a.5.5 0 10.833.555l1-1.5c.009-.014.011-.03.019-.045a.472.472 0 00.035-.085c.005-.018.016-.033.02-.051.003-.018 0-.035.001-.052zM3.884 1.327C5.433 1.81 7.704 2.95 7.97 5.5H1.38l2.504-4.173zm.006 9.357L1.38 6.5h6.59c-.262 2.58-2.528 3.71-4.08 4.184z"}})])
          )
        }
      }
    